// extracted by mini-css-extract-plugin
export var aboveInput = "_ng-0";
export var actionButton = "_ng-5";
export var actionButtonContainer = "_ng-1";
export var actionIcon = "_ng-6";
export var aiInfoContainer = "_ng-2";
export var attachmentWrapper = "_ng-7";
export var bold = "_ng-3";
export var checkIcon = "_ng-8";
export var clickingRecipientBar = "_ng-11";
export var commentThreadSwitch = "_ng-a";
export var draftImage = "_ng-b";
export var draftImageContainer = "_ng-c";
export var draftImages = "_ng-e";
export var editButton = "_ng-g";
export var editor = "_ng-f";
export var editorContainer = "_ng-y";
export var editorErrorTooltipWrapper = "_ng-9";
export var headerDivider = "_ng-h";
export var icon = "_ng-i";
export var info = "_ng-j";
export var internal = "_ng-n";
export var internalDivider = "_ng-k";
export var internalMessage = "_ng-l";
export var messageInputCard = "_ng-m";
export var messageInputForm = "_ng-o";
export var messageInputFormInternal = "_ng-p";
export var options = "_ng-q";
export var publicMessageCustomer = "_ng-s";
export var publicMessageMerchant = "_ng-r";
export var removeImageButton = "_ng-d";
export var replyButtons = "_ng-t";
export var showSignatureButton = "_ng-u";
export var spinner = "_ng-v";
export var verticalButtonDivider = "_ng-4";
export var visibilitySelector = "_ng-w";
export var warning = "_ng-x";
export var wrappingText = "_ng-z";
export var writingInternalNoteTopBorder = "_ng-10";